import React from 'react';

const CustomTooltip = ({ active, payload, label, currentView }) => {
    if (active && payload && payload.length) {
        // const data = payload[0].payload; // Access the full data item if needed
        return (
            <div className="custom-tooltip">
                <p className="tooltip-label">{`${label}`}</p>
                <p className="tooltip-value">{`${payload[0].value} Medicines`}</p>
                {/* Conditionally add instruction based on current view */}
                {currentView === 'overview' && <p className="tooltip-instruction">Click bar to explore '{label}' subtypes</p>}
                {currentView === 'type' && <p className="tooltip-instruction">Click bar to view '{label}' medicines</p>}
                {/* No instruction needed for subtype view tooltips currently */}
            </div>
        );
    }
    return null;
};

export default CustomTooltip;